var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScrolldown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 497.16 497.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(188.39 55.85) rotate(-12.62)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(217.19 48.65) rotate(-2.7)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.99, 0.13, -0.13, 0.99, 257.33, 46.85)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(288.42 50.12) rotate(17.54)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9, 0.44, -0.44, 0.9, 327.18, 62.93)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.84, 0.54, -0.54, 0.84, 346.88, 72.59)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(365.56 84.67) rotate(37.95)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(377.47 92.88) rotate(45.15)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.56, 0.83, -0.83, 0.56, 402.9, 117.67)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(426.12 149.95) rotate(68.69)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "W"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(444.21 197.47) rotate(80.98)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "N"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(449.4 233.73) rotate(88.2)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(450.43 248.42) rotate(94.55)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(447.67 278.99) rotate(101)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(445.44 293.48) rotate(107.5)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(437.23 321.98) rotate(117.48)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.61, 0.79, -0.79, -0.61, 418.59, 357.58)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.74, 0.67, -0.67, -0.74, 400.06, 382.78)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.83, 0.55, -0.55, -0.83, 369.5, 409.84)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(351.25 422.06) rotate(152.75)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(331.46 432.16) rotate(158.07)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(318.41 438.34) rotate(165.37)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "D"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(284.21 447.83) rotate(176.14)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(244.57 451.59) rotate(-171.18)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "W"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(194.39 443.38) rotate(-158.89)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "N"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(160.42 429.68) rotate(-151.6)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, 147.26, 423.21)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(122.25 405.39) rotate(-138.73)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(110.83 396.12) rotate(-132.31)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(90.31 374.68) rotate(-122.43)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(68.86 340.74) rotate(-112.26)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(56.36 312.1) rotate(-102.01)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(48.39 272.05) rotate(-93.21)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.05, -1, 1, 0.05, 47.05, 250.13)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(48.27 227.91) rotate(-81.8)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.27, -0.96, 0.96, 0.27, 49.48, 213.51)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.44, -0.9, 0.9, 0.44, 58.42, 179.17)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.63, -0.78, 0.78, 0.63, 75.09, 143.05)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "W"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.78, -0.63, 0.63, 0.78, 107.52, 103.83)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "N"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.85, -0.52, 0.52, 0.85, 136.42, 81.33)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(148.62 73.17) rotate(-25.05)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(176.57 60.48) rotate(-18.55)",
    fontSize: 56,
    fill: "currentColor",
    fontFamily: "Poppins-Regular, Poppins"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrolldown);
export default __webpack_public_path__ + "static/media/scrolldown.6797156f2981c42a6e808fef5fdfe4c8.svg";
export { ForwardRef as ReactComponent };